import React from 'react'
import { useParams } from 'react-router-dom'
import Enas_Food from '../Pdf/2023-02-17_Enas_Food.pdf'
import Risen_Food_Menu from '../Pdf/2023_02_14_BC_Risen_Food_Menu.pdf'
import WaterSports from '../Pdf/Seawake Soluna send-20-3-23.pdf'

const DocumentViewer = () => {
    const params = useParams()

    const getDoc = () => {
        switch (params.doc) {
            case 'Enas_Food':
                return Enas_Food
            case 'Risen_Food_Menu':
                return Risen_Food_Menu
            case 'WaterSports':
                return WaterSports
            default:
                return null
        }
    }
    return (
        <div>
            <object data={getDoc()} type="application/pdf" width="100%" height="100%">
                <p>Alternative text - include a link <a href="http://africau.edu/images/default/sample.pdf">to the PDF!</a></p>
            </object>
        </div>
    )
}

export default DocumentViewer